/**
 * The primary space variants available in our primitives
 */
type SpaceSize = 'smaller' | 'small' | 'big' | 'bigger' | 'biggest' | 'base' | 0 | '0'

/**
 * The standard interface for primitives
 */
export interface SpaceProp {
	space?: SpaceSize
}

/**
 * Used in primitives to provide standard space without the pain of remembering
 * @param space - the space size
 * @return a string which can be used as the value in a CSS Object key that would accept a width value
 */
export const space = ({ space = 'base' }: SpaceProp): string => {
	switch (space) {
		case 'base':
			return 'var(--space)'
		case 0:
		case '0':
			return '0'
		default:
			return `var(--space-${space})`
	}
}
